<template>
  <div class="not-found-wrapper" data-testid="testid-not-found-content-state">
    <div class="not-found-content">
      <img
        src="@/assets/images/error-404-notfound.png"
        alt="Not Found"
        class="error-404-illustration"
        data-testid="image-err-404-not-found"
      />
      <p class="error-message" data-testid="error-message">{{ errMsg }}</p>
      <p class="error-description" data-testid="error-description">
        {{ errDesc }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  errMsg?: string;
  errDesc?: string;
}

const props = withDefaults(defineProps<Props>(), {
  errMsg: "ขออภัย ไม่พบหน้าเว็บไซต์ที่คุณต้องการ",
  errDesc: "กรุณาตรวจสอบ URL หรือทำรายการใหม่ภายหลัง",
});
</script>

<style scoped>
@reference "../assets/styles/main.css";
.not-found-wrapper {
  @apply flex justify-center;
}

.not-found-content {
  @apply flex flex-col justify-center max-w-[736px] max-h-[732px];
}

.error-404-illustration {
  @apply mb-4 w-full max-w-xs mx-auto aspect-[16/9];
}

.error-message,
.error-description {
  @apply text-[12px] leading-[16px] font-[500] text-[#292828] text-center md:text-[14px] md:leading-[20px];
}
</style>
